import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "main-slider__dark-overlay abs ev-none" }, null, -1)
const _hoisted_2 = ["data-mouse-text"]
const _hoisted_3 = ["hasVideo"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["srcset"]
const _hoisted_6 = ["srcset"]
const _hoisted_7 = ["src", "alt"]

import { onMounted, onUnmounted, ref, computed } from "vue";
import type { Ref } from "vue";
import Pagination from "./Parts/MainSlider.pagination.vue";
import Description from "./UI/MainSlider.description.vue";
import { handleResize } from "../../../composables/resizeHandler"
import { handleSwipeDirection } from "@/composables/swipeHandler";
import clearTimeoutHandler from "../../../composables/clearTimeoutHandler"
import { useMenuStore } from "@/store/pinia/menu";
import fn from "@/helpers/func";

// RESIZE HANDLER

export default /*#__PURE__*/_defineComponent({
  props: {
  contentData: {
    type: Object,
  },
},
  setup(__props) {

const props = __props

/**
 * @author Irakli Kandelaki
 */

// IMPORTS
const { windowWidth, windowHeight } = handleResize();
const { handleSwipeStart, handleSwipeEnd, direction } = handleSwipeDirection();

// INIT STORE
const store = useMenuStore();

// store.isMainSliderLoaded = false;
// PROPS


// REFS
const isMountedStepOne: Ref<boolean> = ref(false)
const isMountedStepTwo: Ref<boolean> = ref(false)
const isMountedStepThree: Ref<boolean> = ref(false)
const isTransitioning: Ref<boolean> = ref(false)
const isTransitioningStepOne: Ref<boolean> = ref(false)
const isTransitioningStepTwo: Ref<boolean> = ref(false)
const showTeaserBar: Ref<boolean> = ref(false)



const activeIndex: Ref<number> = ref(0);
const prevIndex: Ref<number> = ref(props.contentData.length - 1)

// REFS - TIMEOUTS
const isMountedStepTwoTO: Ref<number | null> = ref(null);
const isMountedStepThreeTO: Ref<number | null> = ref(null);
const prevVideoStopTO: Ref<number | null> = ref(null);
const showTeaserBarTO: Ref<number | null> = ref(null);
const scrollStatusTO: Ref<number | null> = ref(null);

// COMPUTED
const ctaText = computed(() => fn.tr('Explore'))

// LIFECYCLE HOOKS

// LIFECYCLE HOOKS - MOUNTED
onMounted(() => {
  store.headerScrolledValue = windowHeight.value * 0.4;
  window.innerWidth >= 1024 ? store.disableScrollStatus = true : store.disableScrollStatus = false;



  const slides = document.querySelectorAll<HTMLMediaElement>('.main-slider__slide');

  // let loadedNum = 1;

  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);


  const hasFirstSlideVideo = slides[0].querySelector('video');

  if (slides[0].getAttribute('hasVideo')) {
    isMountedStepOne.value = true;

    // setTimeout(() => {
    //   store.isMainSliderLoaded = true;
    // }, 800);

    isMountedStepTwoTO.value = window.setTimeout(() => {
      isMountedStepTwo.value = true;
    }, 1000);

    isMountedStepThreeTO.value = window.setTimeout(() => {
      isMountedStepThree.value = true;
      store.isMountedStepThree = true;
    }, 2000);

    showTeaserBarTO.value = window.setTimeout(() => {
      showTeaserBar.value = true;
    }, 2200);

    scrollStatusTO.value = window.setTimeout(() => {
      store.disableScrollStatus = false;

    }, 2600);

    const readyStateInt = setInterval(() => {



      if (hasFirstSlideVideo && hasFirstSlideVideo.readyState === 4 || isIOS) {

        // if (store.isPageTransitioningStepTwo || store.isDefaultPageTransitioningStepOne || store.isPageTransitioningStepOne) return;
        isMountedStepOne.value = true;
        hasFirstSlideVideo.play();
        setTimeout(() => {
          store.isMainSliderLoaded = true;
        }, 800);

        isMountedStepTwoTO.value = window.setTimeout(() => {
          isMountedStepTwo.value = true;
        }, 1300);

        isMountedStepThreeTO.value = window.setTimeout(() => {
          isMountedStepThree.value = true;
          store.isMountedStepThree = true;
        }, 2300);

        showTeaserBarTO.value = window.setTimeout(() => {
          showTeaserBar.value = true;
        }, 2500);

        scrollStatusTO.value = window.setTimeout(() => {
          store.disableScrollStatus = false;

        }, 2600);
        clearInterval(readyStateInt);



      }
    }, 100);
    return;
  }




  // })
  // })

});


// LIFECYCLE HOOKS - UNMOUNTED
onUnmounted(() => {
  clearTimeoutHandler(prevVideoStopTO.value);
  clearTimeoutHandler(isMountedStepTwoTO.value);
  clearTimeoutHandler(isMountedStepThreeTO.value);
  clearTimeoutHandler(showTeaserBarTO.value);
  clearTimeoutHandler(scrollStatusTO.value);
});


// METHODS
const setActiveSlide = (val: number) => {
  clearTimeoutHandler(prevVideoStopTO.value);
  let isPrevVideoPlaying: boolean = false;
  activeIndex.value = val;
  const slides = document.querySelectorAll<HTMLVideoElement>('.main-slider__slide');
  const slideVideo = slides[val].querySelector('video')
  const slidePrevVideo = slides[prevIndex.value].querySelector('video');
  if (!slideVideo) return;
  slideVideo.currentTime = 0;
  slideVideo.play();

  if (!slidePrevVideo) return;
  prevVideoStopTO.value = window.setTimeout(() => {
    slidePrevVideo.onplaying = () => {
      isPrevVideoPlaying = true;
    }
    slidePrevVideo.onplaying = () => {
      isPrevVideoPlaying = false;
    }
    if (isPrevVideoPlaying) {
      slidePrevVideo.currentTime = 0;
      slidePrevVideo.pause();

    }
  }, 700);
}





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", {
      class: _normalizeClass(["main-slider flex column rel ov-hidden", { 'is-dark': _unref(store).isDark, 'is-mounted-step-1': isMountedStepOne.value, 'is-mounted-step-2': isMountedStepTwo.value, 'is-mounted-step-3': isMountedStepThree.value, 'is-transitioning': isTransitioning.value, 'is-transitioning-step-1': isTransitioningStepOne.value, 'is-transitioning-step-2': isTransitioningStepTwo.value }])
    }, [
      _hoisted_1,
      _createElementVNode("div", {
        class: "main-slider__inner ov-hidden pointer",
        "data-scroll": "",
        "data-scroll-speed": "-2",
        onTouchstart: _cache[0] || (_cache[0] = ($event: any) => (_unref(handleSwipeStart)($event))),
        onTouchend: _cache[1] || (_cache[1] = ($event: any) => (_unref(handleSwipeEnd)($event))),
        style: _normalizeStyle({ height: _unref(windowWidth) <= 1023 ? _unref(windowHeight) + 30 + 'px' : '' }),
        "data-scale-type": "1",
        "data-component-name": "main-slider",
        "data-mouse-text": _unref(ctaText)
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.contentData?.data?.list, (vid, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["main-slider__slide rel ov-hidden", { 'main-slider__slide--active': activeIndex.value === index, 'main-slider__slide--prev': prevIndex.value === index }]),
            key: index,
            hasVideo: vid?.desktop_video?.videoFile?.url ? true : vid?.mobile_video?.videoFile?.url ? true : false
          }, [
            (_unref(windowWidth) >= 1024 && vid?.desktop_video?.videoFile?.url || _unref(windowWidth) <= 1023 && vid?.mobile_video?.videoFile?.url)
              ? (_openBlock(), _createElementBlock("video", {
                  key: 0,
                  class: "abs",
                  style: _normalizeStyle({
            display: index === activeIndex.value || index === activeIndex.value && isTransitioningStepOne.value || index === prevIndex.value
              && isTransitioningStepOne.value ? 'block' : 'none'
          }),
                  src: 
  _unref(windowWidth) >= 1024
    ? vid?.desktop_video?.videoFile?.url
    : vid?.mobile_video?.videoFile?.url
,
                  preload: "auto",
                  loop: "",
                  muted: "",
                  playsinline: ""
                }, null, 12, _hoisted_4))
              : _createCommentVNode("", true),
            _createElementVNode("picture", null, [
              _createElementVNode("source", {
                media: "(max-width:767px)",
                srcset: vid?.images[0]?.devices.mobile
              }, null, 8, _hoisted_5),
              _createElementVNode("source", {
                media: "(max-width:1200px)",
                srcset: vid?.images[0]?.devices.tablet
              }, null, 8, _hoisted_6),
              (!vid?.desktop_video?.videoFile?.url)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: vid?.images[0]?.devices.desktop,
                    alt: vid?.images[0]?.title ? vid?.images[0]?.title : vid?.title
                  }, null, 8, _hoisted_7))
                : _createCommentVNode("", true)
            ])
          ], 10, _hoisted_3))
        }), 128))
      ], 44, _hoisted_2),
      _createVNode(Pagination, {
        isMountedStepTwo: isMountedStepTwo.value,
        isMountedStepThree: isMountedStepThree.value,
        showTeaserBar: showTeaserBar.value,
        content: props.contentData?.data?.list,
        direction: _unref(direction),
        onActiveIndex: _cache[2] || (_cache[2] = (val) => setActiveSlide(val)),
        onPrevIndex: _cache[3] || (_cache[3] = (val) => prevIndex.value = val),
        onSlideChange: _cache[4] || (_cache[4] = (val) => isTransitioning.value = val),
        onIsTransitioningStepOne: _cache[5] || (_cache[5] = (val) => isTransitioningStepOne.value = val),
        onIsTransitioningStepTwo: _cache[6] || (_cache[6] = (val) => isTransitioningStepTwo.value = val)
      }, null, 8, ["isMountedStepTwo", "isMountedStepThree", "showTeaserBar", "content", "direction"])
    ], 2),
    _createVNode(Description, {
      description: props.contentData?.data?.list[activeIndex.value].description,
      link: props.contentData?.data?.list[activeIndex.value]?.link,
      isTransitioningStepOne: isTransitioningStepOne.value
    }, null, 8, ["description", "link", "isTransitioningStepOne"])
  ], 64))
}
}

})